"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackChangeRateInfoClick = trackChangeRateInfoClick;
var _analytics = require("@cian/analytics");
function trackChangeRateInfoClick(isBankMortgage) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_info',
    label: 'open_changes_rate_info',
    useLastProducts: true,
    page: {
      extra: {
        is_bank_mortgage: isBankMortgage
      }
    }
  });
}